import { GET_MATCHING_SYM_DIA } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface SymDiaResponse {
    symptoms?: SymDia[];
    diagnoses?: SymDia[];
}
export interface SymDia {
    id: string;
    name: string;
    icd10_code?: string;
    icd10_name?: string;
}

export default (text?: string, gender?: 'M' | 'F' | 'O', spec?: string): Promise<SymDiaResponse> =>
    fetchWithRefresh(
        GET_MATCHING_SYM_DIA((text || '').replace(/[^a-zA-Z0-9 ]/g, ''), gender, spec),
    ).then((res) => res.json());
